module.exports = __webpack_public_path__ + "media/images/premium/premium-main_sp-459a0eaab10ed845823c61c31a32da9a.jpg";